export const ImageTypeOptionInfo = [
  { id: "cover", name: "cover" },
  { id: "thumbnail", name: "thumbnail" },
  { id: "card", name: "card" },
  { id: "head", name: "head" }
];
